import React, { useState, useEffect } from 'react';
import { QualitySelector } from './QualitySelector';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

export const VideoMetadataCard = ({ videoInfo, quality, setQuality, onDownload, loading }) => {
    const [thumbSrc, setThumbSrc] = useState('');

    useEffect(() => {
        if (!videoInfo?.thumbnail) return;
        const t = videoInfo.thumbnail;
        const isIgCdn = /(instagram\.com|cdninstagram|fbcdn\.net)/i.test(t);
        if (isIgCdn) {
            setThumbSrc(`${API_BASE}/api/image-proxy?url=${encodeURIComponent(t)}`);
        } else {
            setThumbSrc('');
        }
    }, [videoInfo?.thumbnail]);

    return (
        <div className="preview-card">
            <div
                className="preview-media"
                style={
                    videoInfo.width && videoInfo.height
                        ? { aspectRatio: `${videoInfo.width} / ${videoInfo.height}` }
                        : undefined
                }
            >
                {videoInfo.thumbnail && (
                    <img
                        src={thumbSrc || videoInfo.thumbnail}
                        alt={videoInfo.title}
                        onError={() => {
                            if (!thumbSrc) {
                                setThumbSrc(`${API_BASE}/api/image-proxy?url=${encodeURIComponent(videoInfo.thumbnail)}`);
                            }
                        }}
                    />
                )}
            </div>
            <div className="preview-meta">
                <h2>{videoInfo.title}</h2>
                {videoInfo.uploader && <p>by {videoInfo.uploader}</p>}
                <div className="format-row">
                    <label htmlFor="singleVideoQuality">Quality</label>
                    <QualitySelector
                        id="singleVideoQuality"
                        type="video"
                        value={quality}
                        onChange={(e) => setQuality(e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
};
